class SaleCountdown extends HTMLElement {
  constructor() {
    super();
    this._timer = null;
    this._end = null;

    this.$days = null;
    this.$hours = null;
    this.$mins = null;
    this.$secs = null;
  }

  connectedCallback() {
    this.$days = this.querySelector('[data-days]');
    this.$hours = this.querySelector('[data-hours]');
    this.$mins = this.querySelector('[data-mins]');
    this.$secs = this.querySelector('[data-secs]');

    this._readEndFromAttr();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  _readEndFromAttr() {
    const raw = this.getAttribute('data-end');
    if (!raw) { this._end = null; return; }
    const d = new Date(raw);
    this._end = isNaN(d.getTime()) ? null : d;
  }

  pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  stop() {
    if (this._timer) clearTimeout(this._timer);
    this._timer = null;
  }

  start() {
    this.stop();
    this._tick();
  }

  _tick() {
    if (!this._end || !this.$days) return;

    const diffMs = this._end.getTime() - Date.now();

    if (diffMs <= 0) {
      this._render(0, 0, 0, 0);
      this.setAttribute('data-expired', 'true');

      const action = (this.getAttribute('data-expired-action') || '').toLowerCase();
      if (action === 'hide') this.style.display = 'none';
      return;
    }

    const totalSec = Math.floor(diffMs / 1000);
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    this._render(days, hours, mins, secs);

    const nextIn = 1000 - (Date.now() % 1000);
    this._timer = setTimeout(() => this._tick(), nextIn);
  }

  _render(days, hours, mins, secs) {
    this.$days.textContent = this.pad(days);
    this.$hours.textContent = this.pad(hours);
    this.$mins.textContent = this.pad(mins);
    this.$secs.textContent = this.pad(secs);
  }

  setEnd(end) {
    if (!end) { this._end = null; this.style.display = 'none'; return; }
    const d = end instanceof Date ? end : new Date(end);
    if (isNaN(d.getTime())) { this._end = null; this.style.display = 'none'; return; }
    this._end = d;
    this.style.display = '';
    this.removeAttribute('data-expired');
    this.start();
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
